import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { NavigationItemComponent } from './navigation-item/navigation-item.component';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/@dva/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [NavigationComponent, NavigationItemComponent],
  exports: [NavigationComponent],
})
export class NavigationModule {}
